import { render, staticRenderFns } from "./pregunta-respuesta-multiple.vue?vue&type=template&id=4b87d5c4&scoped=true"
import script from "./pregunta-respuesta-multiple.vue?vue&type=script&lang=js"
export * from "./pregunta-respuesta-multiple.vue?vue&type=script&lang=js"
import style0 from "./pregunta-respuesta-multiple.vue?vue&type=style&index=0&id=4b87d5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b87d5c4",
  null
  
)

export default component.exports